"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _primitives = require("./primitives");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FILTER_BY = {
  '3-side': 3,
  '4-side': 4,
  full: 0
};

var ImageGrid = function ImageGrid(_ref) {
  var images = _ref.images,
      _ref$mainImageIndex = _ref.mainImageIndex,
      mainImageIndex = _ref$mainImageIndex === void 0 ? 0 : _ref$mainImageIndex,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? [240, 490] : _ref$height,
      layout = _ref.layout,
      _ref$showMediaCounter = _ref.showMediaCounterButton,
      showMediaCounterButton = _ref$showMediaCounter === void 0 ? true : _ref$showMediaCounter,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;

  var mainImage = images[mainImageIndex];
  var sideImages = images.map(function (image, index) {
    return _objectSpread(_objectSpread({}, image), {}, {
      originalIndex: index
    });
  }).filter(function (image, index) {
    return index !== mainImageIndex;
  }).filter(function (image, index) {
    return index < FILTER_BY[layout];
  });
  return /*#__PURE__*/_react["default"].createElement(_primitives.StyledGrid, {
    layout: layout,
    height: height
  }, /*#__PURE__*/_react["default"].createElement(_primitives.StyledMainImage, null, /*#__PURE__*/_react["default"].createElement(_primitives.StyledImage, (0, _extends2["default"])({
    "data-testid": "main-image"
  }, mainImage, {
    loading: "lazy",
    onClick: function onClick() {
      return _onClick(mainImageIndex);
    }
  }))), sideImages.length > 0 && /*#__PURE__*/_react["default"].createElement(_primitives.StyledThumbnails, {
    layout: layout
  }, sideImages.map(function (image, index) {
    return /*#__PURE__*/_react["default"].createElement(_primitives.StyledButton, {
      key: index,
      onClick: function onClick() {
        return _onClick(image.originalIndex);
      },
      layout: layout
    }, /*#__PURE__*/_react["default"].createElement(_primitives.StyledImage, (0, _extends2["default"])({}, image, {
      loading: "lazy"
    })));
  })), showMediaCounterButton && /*#__PURE__*/_react["default"].createElement(_primitives.StyledMediaCounterButton, {
    totalImages: images.length,
    variant: "light",
    onClick: function onClick() {
      return _onClick(mainImageIndex);
    }
  }));
};

ImageGrid.propTypes = {
  images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string.isRequired,
    alt: _propTypes["default"].string.isRequired
  })).isRequired,
  layout: _propTypes["default"].oneOf(['full', '3-side', '4-side']).isRequired,
  mainImageIndex: _propTypes["default"].number,
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].array]),
  showMediaCounterButton: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
var _default = ImageGrid;
exports["default"] = _default;